import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useFormValidation } from '../../../hooks/useFormValidation'
import React, { useEffect } from 'react'
import { buildControlsExt, checkboxInput } from '../../inputs/controls'
import { getLabel } from '../../../utils/getLabel'
import { modifyActionParameter } from '../../../store/actions/actionsActions'
import { useDebouncedValue } from '../../../hooks/useDebouncedValue'
import { PATH_JOINER } from '../../models/utils/getConfigBitPath'

interface BoolACTNProps {
    dataPath: string
    data: any
    dataSchema: any
    name: string
    wrapper?: string
}

export const BoolACTN = (props: BoolACTNProps) => {
    const { data = {}, dataSchema, name, dataPath, wrapper } = props
    const { description, name: inputLabel, default: defaultValue } = dataSchema

    const dispatch = useAppDispatch()
    const path = [...(dataPath.split(PATH_JOINER)), name]

    const [inputState, setInputState, touched] = useFormValidation(
        data || {},
        {}
    )
    const debouncedInputState = useDebouncedValue(inputState, 500)

    const label = getLabel(name, inputLabel)

    const controlDescriptors = [
        checkboxInput(
            name,
            description,
            label,
            '',
            false,
            '',
            undefined,
            defaultValue
        ),
    ]

    const BoolInput = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched,
    )

    useEffect(() => {
        dispatch(
            modifyActionParameter({
                path,
                data: inputState,
            })
        )
    }, [debouncedInputState, dispatch])

    return <div className={`${!wrapper ? 'w-100' : ''}`}>{BoolInput}</div>
}
